import React, { useState } from 'react'
import { ThumbDown, ThumbUp } from '@mui/icons-material'
import { CircularProgress, Button } from '@mui/material'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { submitReviewAnswer } from 'services/apiKYP'
import { DialogConfirm } from 'components'

import { USER_ROLES } from 'utils/constants/userRoles'
import {
  REVIEW_ACTIONS,
  REVIEW_ACTIONS_MESSAGES,
} from 'utils/constants/kypStatuses'
import Colors from 'utils/Colors'

import styles from './styles'

const ManualAnalysisForm = (props) => {
  const { reviewData, updateReview } = props
  const classes = styles()

  const issueId = reviewData.uuid

  const token = useSelector((state) => state.auth.access_token)

  const [error, setError] = useState(false)
  const [open, setOpen] = useState(false)
  const [comment, setComment] = useState('')
  const [decision, setDecision] = useState('')
  const [loading, setLoading] = useState(false)

  const handleTextField = (value) => {
    setComment(value)
  }

  const handleSubmit = async (issue_id, review_decision, reviewer_comment) => {
    setLoading(true)
    const data = {
      uuid: issue_id,
      decision: review_decision,
      reviewer_comment: reviewer_comment,
    }
    submitReviewAnswer(token, data)
      .then((response) => {
        toast.success('Análise enviada com sucesso')
        updateReview(response.data)
      })
      .catch((err) => {
        const message = err?.response?.data?.detail

        toast.error(
          message !== '' && message !== null && message !== undefined
            ? message
            : 'Houve uma falha durante o envio da análise, favor tente novamente',
        )
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const openConfirmDialog = () => {
    setOpen(true)
  }

  const closeConfirmDialog = () => {
    setOpen(false)
    setDecision('')
  }

  const handleConfirm = () => {
    handleSubmit(issueId, decision, comment)
    closeConfirmDialog()
  }

  const checkRequiredFields = (action) => {
    const option = REVIEW_ACTIONS[action]

    const require_comments = [REVIEW_ACTIONS.REPROVED, REVIEW_ACTIONS.FORWARDED]

    if (comment === '' && require_comments.includes(option)) {
      setError(true)
      toast.error('Preencha o campo justificativa')
    } else {
      setDecision(option)
      setError(false)
      openConfirmDialog()
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.comment}>
        <div>
          <span className={classes.label}>Justificativa</span>
          {error && (
            <span className={classes.errorText}> * Campo obrigatório</span>
          )}
        </div>

        <textarea
          id="justificative"
          type="text"
          value={comment}
          className={classes.textArea}
          placeholder="Digite o motivo da análise..."
          onChange={(event) => handleTextField(event.target.value)}
          style={{ borderColor: error ? Colors.red : 'inherit' }}
        />
      </div>

      <div className={classes.buttonContainer}>
        {loading ? (
          <CircularProgress size={32} style={{ marginRight: 20 }} />
        ) : (
          <div className={classes.buttonContainer}>
            <div className={classes.rightWrapper}>
              <Button
                id="approve"
                onClick={() => checkRequiredFields(REVIEW_ACTIONS.APPROVED)}
                className={classes.iconButton}
                style={{ backgroundColor: Colors.green, color: '#FFFFFF' }}
              >
                <ThumbUp fontSize="small" />
                Aprovar
              </Button>
              <Button
                id="reprove"
                onClick={() => checkRequiredFields(REVIEW_ACTIONS.REPROVED)}
                className={classes.iconButton}
                style={{ backgroundColor: Colors.red, color: '#FFFFFF' }}
              >
                <ThumbDown fontSize="small" />
                Reprovar
              </Button>
            </div>
            {reviewData.current_review_area === USER_ROLES.MANAGER ? null : (
              <div className={classes.leftWrapper}>
                <Button
                  variant="contained"
                  onClick={() => checkRequiredFields(REVIEW_ACTIONS.FORWARDED)}
                >
                  Transferir análise para superior
                </Button>
              </div>
            )}
          </div>
        )}
      </div>
      <DialogConfirm
        open={open && decision !== ''}
        onCancel={closeConfirmDialog}
        onConfirm={handleConfirm}
        title={`Tem certeza de que deseja ${REVIEW_ACTIONS_MESSAGES[decision]} este review?`}
      >
        Está ação é irreversível e não podera ser desfeita.
      </DialogConfirm>
    </div>
  )
}

export default ManualAnalysisForm
